import React from 'react'
import NavigationBar from '../Commons/NavigationBar'
import CreateTypeForm from './TypeForm'
import { getToken } from '../Commons/Authentication'
import { ToastContainer, ToastMessage } from 'react-toastr'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import { hashHistory } from 'react-router'
import _ from 'lodash'
import moment from 'moment'

export default class TypeComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = ({ type: '', isUpdate: false })
  }

  componentWillMount () {
    if (!_.isEmpty(this.props.params)) {
      console.log(this.props.params)
      this.setState({ type: this.props.params.type, isUpdate: true })
    }
  }

  render () {
    document.title = 'Registrar Tipos - CORE 3.0'
    return (
      <div className='main-information-container'>
        <NavigationBar/>
        <div className='registration-container-type'>
          <div className='type-profile'>
            <CreateTypeForm typeName={this.state.type} isUpdate={this.state.isUpdate} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Type/TypeComponent.js